module.exports = __webpack_public_path__ + "static/media/projets.c018a599.png";